import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid1x3Vertical: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDotGrid1x3Vertical"><Path d="M13.75 2H10.25V5.5H13.75V2Z" fill="currentColor"/><Path d="M13.75 10.25H10.25V13.75H13.75V10.25Z" fill="currentColor"/><Path d="M13.75 18.5H10.25V22H13.75V18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid1x3Vertical;
